import * as React from 'react'
export const Th = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 85.334h512V426.66H0z" />
    <path fill="#0052B4" d="M0 194.056h512v123.882H0z" />
    <path fill="#D80027" d="M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z" />
  </svg>
)
